import { render, staticRenderFns } from "./StationPlaceEvents.vue?vue&type=template&id=237d4904&scoped=true&"
import script from "./StationPlaceEvents.vue?vue&type=script&lang=js&"
export * from "./StationPlaceEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237d4904",
  null
  
)

/* custom blocks */
import block0 from "./StationPlaceEvents.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('237d4904')) {
      api.createRecord('237d4904', component.options)
    } else {
      api.reload('237d4904', component.options)
    }
    module.hot.accept("./StationPlaceEvents.vue?vue&type=template&id=237d4904&scoped=true&", function () {
      api.rerender('237d4904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/StationPlaceEvents/StationPlaceEvents.vue"
export default component.exports